import React, {FC} from 'react'
import clsx from 'clsx'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {ID} from '@/_metronic/helpers'
type OverviewCellProps = {
  name: string
  id: ID
  cover?: string
}

const OverviewCell: FC<OverviewCellProps> = ({name, cover, id}) => {
  const to = `/p2c/product/${id}/overview`
  const img = cover ? 
    cover :
    '/media/svg/files/blank-image.svg'
  return (
    <div className="d-flex align-items-center">
      <Link
        className="symbol symbol-50px"
        to={to}
      >
        <span
          className="symbol-label"
          style={{backgroundImage: `url(${img})`}}
        />
      </Link>

      <div className="ms-5">
        <Link
          className="text-gray-600 fw-bold text-hover-primary"
          to={to}
        >
          {name}
        </Link>
      </div>
    </div>
  )
}

type StatusCellProps = {
  status: string
}

const StatusCell: FC<StatusCellProps> = ({status}) => {
  const intl = useIntl()
  return (
    <div className={clsx('badge', {
      'badge-light-success': status === 'PUBLISHED', 
      'badge-light-danger': status === 'DISABLED',
      'badge-light-primary': status === 'DRAFT'
    })}>
      {intl.formatMessage({id: `P2C.PRODUCT_STATUS_${status}`})}
    </div>
  )
}

type StockCellProps = {
  stock: number
  threshold: number
}

const StockCell: FC<StockCellProps> = ({stock, threshold}) => {
  const rate  = (100 * stock / threshold)
  return (
    <>
      { rate < 20 && (
        <span className={clsx('badge', {
          'badge-light-warning': rate > 15, 
          'badge-light-danger': rate < 15
        })} title={`Threshold: ${threshold.toString() }`}>Low stock</span>
      )}

      <span className={clsx('fw-bold ms-3', {
        'text-danger': rate < 15, 
        'text-warning': rate < 20
      })} title={`Threshold: ${threshold.toString() }`}>
        {stock}
      </span>
    </>
  )
}

type TypeCellProps = {
  type: string
}

const TypeCell: FC<TypeCellProps> = ({type}) => {
  const intl = useIntl()
  return (
    <div className={clsx('badge', {
      'badge-light-info': type === 'GIFT_CARD', 
      'badge-light-primary': type === 'SUBSCRIPTION',
      'badge-light-warning': type === 'CURRENCY',
      'badge-light': type === 'GAME'
    })}>
      {intl.formatMessage({id: `P2C.PRODUCT_TYPE_${type}`})}
    </div>
  )
}

export {
  OverviewCell,
  StatusCell,
  StockCell,
  TypeCell
}
